import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  loadBestSellersRequest: ['payload'],
  setBestSellers: ['payload'],
}, { prefix: '[BEST SELLERS] ' });
